var chunkToChildrenMap = {
	"2348": [
		1189
	],
	"4882": [
		1189
	],
	"5123": [
		1189
	],
	"7339": [
		1189
	],
	"7366": [
		1189
	],
	"7924": [
		1189
	],
	"7996": [
		1189
	]
};
__webpack_require__.f.prefetch = function(chunkId, promises) { Promise.all(promises).then(function() {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}); };